var heading_default = {
  "fontElementMap": "LYiEa",
  "elementSpacing": "widFm",
  "headerOne": "wikFU widFm",
  "headerTwo": "mTX2w widFm",
  "headerThree": "-lY-p widFm",
  "headerFour": "E9-fd widFm",
  "headerFive": "TsH3H widFm",
  "headerSix": "RE144 widFm",
  "child": "pmcak"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
